import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useRef, useEffect } from 'react';
import { default as ChartJS } from 'chart.js/auto';
import { createUseStyles, useTheme } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../../lib/Web5Context";
import { buildChartConfig } from "../../../utils/charts";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Chart');
const Chart = /*#__PURE__*/memo(_ref => {
  let {
    type,
    data,
    getImage
  } = _ref;
  const theme = useTheme();
  const {
    t,
    locale
  } = useWeb5Context();
  const classes = useStyles();
  const containerRef = useRef(null);
  const chartRef = useRef(null);
  useEffect(() => {
    const ctx = chartRef.current.getContext('2d');
    let newData = buildChartConfig({
      type,
      data,
      theme,
      t,
      locale,
      container: containerRef.current
    });
    const myChart = new ChartJS(ctx, newData);
    if (getImage || newData.options) {
      var _newData$options;
      myChart.options.animation = _objectSpread(_objectSpread({}, (newData === null || newData === void 0 ? void 0 : (_newData$options = newData.options) === null || _newData$options === void 0 ? void 0 : _newData$options.animation) || {}), {}, {
        onComplete: props => {
          var _props$chart, _props$chart$toBase;
          if (!getImage) return;
          const imageBase64 = props === null || props === void 0 ? void 0 : (_props$chart = props.chart) === null || _props$chart === void 0 ? void 0 : (_props$chart$toBase = _props$chart.toBase64Image) === null || _props$chart$toBase === void 0 ? void 0 : _props$chart$toBase.call(_props$chart);
          if (!imageBase64) return;
          getImage(imageBase64);
        }
      });
      myChart.update();
    }
    const resizeObserver = new ResizeObserver(() => {
      myChart.resize();
    });
    resizeObserver.observe(chartRef.current);
    return () => {
      myChart.destroy();
      resizeObserver.disconnect();
    };
  }, [type, data, getImage, t, theme, locale]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: containerRef
  }, /*#__PURE__*/React.createElement("canvas", {
    className: classes.chartCanvas,
    ref: chartRef,
    width: "600",
    height: "280",
    onMouseDown: e => e === null || e === void 0 ? void 0 : e.stopPropagation()
  }));
});
export default Chart;